module.exports = __webpack_public_path__ + "c60c1e3d.svg";